import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import cep from 'cep-promise';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Select from '../../components/Select';
import Textarea from '../../components/Textarea';
import Alert from '../../components/Alert';
import Loading from '../../components/Loading';

import './style.css';
import { calculateAge } from '../../utils/age';
import ModalConfirm from '../../components/ModalConfirm';
import ReactTooltip from 'react-tooltip';
import { getStorage } from '../../utils/storage';
import { getLink } from '../../services/host';

class CadastroPaciente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id !== undefined ? props.match.params.id : null,
      nome: '',
      nascimento: '',
      rg: '',
      escolaridade: '',
      escola: '',
      rede_escolar: '',
      raca: '',
      sexo: '',
      endereco: '',
      numero: '',
      bairro: '',
      cep: '',
      cidade: '',
      estado: '',
      diagnostico: '',
      observacao: '',
      successMessages: [],
      errorMessages: [],
      isLoading: false,
      token: getStorage('token'),
      showAlertAge: false,
      alertAgeAlreadyShowed: false,
      lgpdAceito: false,
    };

    this.cadastrar = this.cadastrar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  componentDidMount() {
    document.title = `Cadastro de Paciente`;
    window.scrollTo(0, 0);

    if (this.state.id !== null) {
      this.carregarDados();
    }
  }

  checkCEP(cepAtual) {
    this.setState({ cep: cepAtual });
    cepAtual = cepAtual.replaceAll('_', '');

    if (cepAtual.length >= 9) {
      //remove - e recupera dados de cep
      cep(cepAtual.replace('-', ''))
        .then((response) => {
          console.log(response);
          this.setState({
            cidade: response.city,
            estado: response.state,
          });

          if (
            response.neighborhood !== undefined &&
            response.neighborhood !== ''
          ) {
            this.setState({
              bairro: response.neighborhood,
            });
          }

          if (response.street !== undefined && response.street !== '') {
            this.setState({
              endereco: response.street,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {});
    }
  }

  cadastrar(e) {
    e.preventDefault();
    window.scrollTo(0, 0);

    if (!this.state.lgpdAceito) {
      this.setState({
        errorMessages: [
          'Você deve aceitar os termos de uso para cadastrar o paciente.',
        ],
      });
      return;
    }

    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .post(process.env.REACT_APP_PACIENTE_NEW, this.state)
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState({
            successMessages: response.data.messages,
            id: response.data.id,
          });
        } else {
          this.setState({
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  atualizar(e) {
    e.preventDefault();
    window.scrollTo(0, 0);

    if (!this.state.lgpdAceito) {
      this.setState({
        errorMessages: [
          'Você deve aceitar os termos de uso para atualizar o paciente.',
        ],
      });
      return;
    }

    if (this.state.id === null) {
      this.setState({
        errorMessages: [
          'Ocorreu um erro inexperado. Por favor, tente novamente.',
        ],
      });

      return;
    }

    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .put(process.env.REACT_APP_PACIENTE_UPDATE, this.state, this.state.id)
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState({
            successMessages: response.data.messages,
          });
        } else {
          this.setState({
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  carregarDados() {
    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(process.env.REACT_APP_PACIENTE_GET, this.state.id)
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState(response.data.dados);
          this.setState(response.data.endereco);
        } else {
          this.setState({
            id: null,
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          id: null,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  onChangeBirthdate(birth) {
    birth = birth.replaceAll('_', '');
    if (birth && birth.length === 10) {
      const currentAge = calculateAge(birth);
      if (currentAge && (currentAge < 11 || currentAge > 30)) {
        this.setState({
          showAlertAge: true,
          alertAgeAlreadyShowed: true,
        });
      }
    }
  }

  render() {
    var escolaridade_array = [
      ['Berçário', 'Berçário'],
      ['N1 Educação Infantil', 'N1 Educação Infantil'],
      ['N2 Educação Infantil', 'N2 Educação Infantil'],
      ['N3 Educação Infantil', 'N3 Educação Infantil'],
      ['1º ano Ensino Fundamental', '1º ano Ensino Fundamental'],
      ['2º ano Ensino Fundamental', '2º ano Ensino Fundamental'],
      ['3º ano Ensino Fundamental', '3º ano Ensino Fundamental'],
      ['4º ano Ensino Fundamental', '4º ano Ensino Fundamental'],
      ['5º ano Ensino Fundamental', '5º ano Ensino Fundamental'],
      ['6º ano Ensino Fundamental', '6º ano Ensino Fundamental'],
      ['7º ano Ensino Fundamental', '7º ano Ensino Fundamental'],
      ['8º ano Ensino Fundamental', '8º ano Ensino Fundamental'],
      ['9º ano Ensino Fundamental', '9º ano Ensino Fundamental'],
      ['1º ano Ensino Médio', '1º ano Ensino Médio'],
      ['2º ano Ensino Médio', '2º ano Ensino Médio'],
      ['3º ano Ensino Médio', '3º ano Ensino Médio'],
      ['Superior incompleto', 'Superior incompleto'],
      ['Superior completo', 'Superior completo'],
      ['Pós-graduação', 'Pós-graduação'],
      ['Outros', 'Outros'],
    ];

    return (
      <div>
        <Header />

        <TopPage
          title={
            this.state.id === null ? 'NOVO PACIENTE' : 'ATUALIZAR PACIENTE'
          }
          back={
            this.state.id === null
              ? getLink(`/dashboard`)
              : getLink(`/perfil-paciente/${this.state.id}`)
          }
        />

        <form
          id="cadastro-paciente"
          method="POST"
          onSubmit={(e) => {
            this.state.id !== null ? this.atualizar(e) : this.cadastrar(e);
          }}
        >
          {this.state.successMessages.length > 0 ? (
            <Alert tipo="success" messages={this.state.successMessages} />
          ) : null}
          {this.state.errorMessages.length > 0 ? (
            <Alert tipo="error" messages={this.state.errorMessages} />
          ) : null}

          <Input
            name="nome"
            id="nome"
            placeholder="Nome Completo"
            value={this.state.nome}
            onChange={(e) => {
              this.setState({ nome: e.target.value });
            }}
          />
          <Input
            name="nascimento"
            id="nascimento"
            placeholder="Data de Nascimento"
            mask="99/99/9999"
            value={this.state.nascimento}
            onChange={(e) => {
              this.setState({ nascimento: e.target.value });
              this.onChangeBirthdate(e.target.value);
            }}
          />
          <Input
            name="rg"
            id="rg"
            placeholder="RG"
            mask="99.999.999-*"
            value={this.state.rg}
            onChange={(e) => {
              this.setState({ rg: e.target.value });
            }}
          />
          {/* <Select name="raca" id="raca" placeholder="Raça" options={[["preta", "Preta"], ["parda", "Parda"], ["indígena", "Indígena"], ["amarela", "Amarela"], ["branca", "Branca"]]} value={this.state.raca} onChange={(e) => { this.setState({ raca: e.target.value }) }} /> */}
          <Select
            name="genero"
            id="genero"
            placeholder="Sexo"
            options={[
              ['F', 'Feminino'],
              ['M', 'Masculino'],
            ]}
            value={this.state.sexo}
            onChange={(e) => {
              this.setState({ sexo: e.target.value });
            }}
          />

          <Input
            label="Endereço do paciente"
            name="cep"
            value={this.state.cep}
            id="cep"
            placeholder="CEP"
            mask="99999-999"
            onChange={(e) => {
              this.checkCEP(e.target.value);
            }}
          />
          <Input
            name="endereco"
            value={this.state.endereco}
            id="endereco"
            placeholder="Endereço"
            onChange={(e) => {
              this.setState({ endereco: e.target.value });
            }}
          />
          <Input
            name="numero"
            value={this.state.numero}
            id="numero"
            placeholder="Número"
            onChange={(e) => {
              this.setState({ numero: e.target.value });
            }}
          />
          <Input
            name="bairro"
            value={this.state.bairro}
            id="bairro"
            placeholder="Bairro"
            onChange={(e) => {
              this.setState({ bairro: e.target.value });
            }}
          />
          <Input
            name="cidade"
            value={this.state.cidade}
            id="cidade"
            placeholder="Cidade"
            onChange={(e) => {
              this.setState({ cidade: e.target.value });
            }}
          />
          <Input
            name="estado"
            value={this.state.estado}
            id="estado"
            mask="aa"
            placeholder="Estado"
            onChange={(e) => {
              this.setState({ estado: e.target.value });
            }}
          />

          <Input
            label="Dados sobre escola"
            name="escola"
            id="escola"
            placeholder="Nome da escola"
            value={this.state.escola}
            onChange={(e) => {
              this.setState({ escola: e.target.value });
            }}
          />
          <Select
            name="escolaridade"
            id="escolaridade"
            placeholder="Escolaridade do paciente"
            options={escolaridade_array}
            value={this.state.escolaridade}
            onChange={(e) => {
              this.setState({ escolaridade: e.target.value });
            }}
          />
          <Select
            name="rede_escolar"
            id="rede_escolar"
            placeholder="Rede Escolar"
            options={[
              ['Pública', 'Pública'],
              ['Particular', 'Particular'],
              ['Outros', 'Outros'],
            ]}
            value={this.state.rede_escolar}
            onChange={(e) => {
              this.setState({ rede_escolar: e.target.value });
            }}
          />

          <Textarea
            rows="6"
            label="Diagnóstico"
            name="diagnostico"
            id="diagnostico"
            placeholder="Escreva o diagnóstico do paciente"
            value={this.state.diagnostico}
            onChange={(e) => {
              this.setState({
                diagnostico:
                  e.target.value?.length > 0 ? e.target.value : undefined,
              });
            }}
          />

          <Textarea
            rows="6"
            label="Observação sobre o paciente"
            name="observacao"
            id="observacao"
            placeholder="Observação"
            value={this.state.observacao}
            onChange={(e) => {
              this.setState({ observacao: e.target.value });
            }}
          />

          <div className="lgpd-container">
            <label className="lgpd-label">
              <input
                type="checkbox"
                id="lgpd"
                name="lgpd"
                checked={this.state.lgpdAceito}
                onChange={(e) => {
                  this.setState({ lgpdAceito: e.target.checked });
                }}
                className="lgpd-checkbox"
              />
              <span>
                Li e concordo com a coleta e uso dos dados pessoais deste
                paciente conforme a{' '}
                <strong>
                  Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018)
                </strong>
                , sendo os dados utilizados exclusivamente para fins de
                avaliação e acompanhamento clínico. Consulte nossa{' '}
                <a
                  href="/pdf/politica-de-privacidade.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Política de Privacidade
                </a>
                .
              </span>
            </label>
          </div>

          <div
            className="btn-lgpd-wrapper"
            data-for="tooltip-lgpd"
            data-tip={
              !this.state.lgpdAceito
                ? 'Aceite os termos da LGPD para continuar'
                : null
            }
          >
            <Button
              id="enviar"
              className="full"
              disabled={!this.state.lgpdAceito}
              onClick={(e) => {
                this.state.id !== null ? this.atualizar(e) : this.cadastrar(e);
              }}
            >
              {this.state.id === null ? 'Cadastrar' : 'Atualizar'}
            </Button>
          </div>
          <ReactTooltip id="tooltip-lgpd" place="top" effect="solid" />
          <Link
            to={
              this.state.id === null
                ? getLink(`/dashboard`)
                : getLink(`/perfil-paciente/${this.state.id}`)
            }
            className="cancelar"
          >
            cancelar
          </Link>
        </form>

        {this.state.showAlertAge ? (
          <ModalConfirm
            title="⚠️ Atenção"
            message="O teste é aplicável de 11 a 30 anos. Não há tabelas normativas para a faixa etária informada. O teste poderá ser realizado, no entanto, não serão oferecidas pontuações-padrão e classificação. Deseja prosseguir?"
            onConfirm={() => {
              this.setState({
                showAlertAge: false,
              });
            }}
            onClose={() => {
              this.props.history.push(getLink(`/dashboard`));
            }}
          />
        ) : null}

        {this.state.isLoading ? <Loading /> : null}

        <Footer />
      </div>
    );
  }
}

export default withRouter(CadastroPaciente);
